import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileService } from '../_services/profiles.service';
import { Subscription } from 'rxjs';
import { Procedure } from '../_models/procedure.model';
import { Profile } from '../_models/profile.model';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models/user.model';

@Component({
  selector: 'app-tramites',
  templateUrl: './tramites.component.html',
  styleUrls: ['./tramites.component.scss']
})
export class TramitesComponent implements OnInit, OnDestroy {

  currentProfile: Profile;
  currentUser: User;
  public isCollapsed = false;
  profileSubscription: Subscription;
  procedures: Procedure[];

  constructor(private profilesService: ProfileService,
              private authenticationService: AuthenticationService,
              private router: Router,
              ) { }

  loadProcedures() {
    const novedades: boolean = this.currentUser.userAccessProfile.novedades;
    const certificado: boolean = this.currentUser.userAccessProfile.certificado;
    this.procedures = [];
    this.currentProfile.procedures.forEach(procedure => {
      // this.procedures.push(procedure);

      switch (procedure.profile_type) {
        case 'NOVEDAD':
          if (novedades) {
            this.procedures.push(procedure);
          }
          break;
        case 'CERTIFICADO':
          if (certificado) {
            this.procedures.push(procedure);
          }
          break;
        default:
          this.procedures.push(procedure);
          break;
      }
    });
  }

  checkUserToken() {
    // let isTokenValid = false;
    this.authenticationService.checkUserToken()
      .subscribe((response: any) => {

      },
      error => {

      });
  }

  async ngOnInit() {
    // Get application's user profile
    this.checkUserToken();
    this.currentProfile = this.profilesService.getSelectedProfile();
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      this.loadProcedures();
    } else {
      this.router.navigate(['/']);
    }
    // Subscribe to user's profile change
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      () => {
        this.currentProfile = this.profilesService.getSelectedProfile();
        this.currentUser = this.authenticationService.currentUserValue;
        if (this.currentProfile && this.currentUser) {
          this.loadProcedures();
          this.router.navigate(['/tramites']);
        } else {
          this.router.navigate(['/']);
        }
      }
    );

    document.addEventListener('click', this.interceptClickEvent.bind(this));
  }

  interceptClickEvent(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.tagName === 'A' && target.dataset.linkgroup == 'menuGroup' ) {
      //event.preventDefault(); // Evitar la acción por defecto
      const href = (target as HTMLAnchorElement).href;
      //console.log('Enlace interceptado:', href);
    }
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
    document.removeEventListener('click', this.interceptClickEvent.bind(this));

  }

}
